<template>
  <div class="wx-scan"></div>
</template>

<script>
import { queryWxConfig } from '@/api/common'
import wx from 'weixin-js-sdk'
export default {
  name: 'WXScan',
  created() {
    this.initWxConfig().then(() => {
      this.wxScan()
    })
  },
  methods: {
    initWxConfig() {
      let p = new Promise((resolve, reject) => {
        let url = encodeURIComponent(window.location.href.split('#')[0])
        queryWxConfig(url).then(res => {
          let data = res.data || {}
          wx.config({
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            debug: false,
            // 必填，公众号的唯一标识
            appId: data.appid,
            // 必填，生成签名的时间戳
            timestamp: data.timestamp,
            // 必填，生成签名的随机串
            nonceStr: data.nonceStr,
            // 必填，签名
            signature: data.signature,
            // 必填，需要使用的JS接口列表，所有JS接口列表
            jsApiList: ['checkJsApi', 'scanQRCode']
          })
          resolve()
        })
      })
      return p
    },
    wxScan() {
      wx.ready(() => {
        wx.scanQRCode({
          desc: 'scanQRCode desc',
          needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'] // 可以指定扫二维码还是一维码，默认二者都有
        })
      })
    }
  }
}
</script>

<style>

</style>
